<template>
    <div class="memberInfo" v-track:click :track-params="JSON.stringify({event: 106})">
        <div class="content">
            <div class="flex">
                <div class="group">
                    <div class="name">
                        <div class="title">分享拼团</div>
                        <div class="downTime">
                            <span><i>{{ groupOfferData.flagBit == 1 ? '下一场' : groupOfferData.flagBit === 2 ? '距结束' : '距开始' }}</i></span>
                            <span v-if="groupOfferData.flagBit == 1">{{ groupOfferData.nextStartTime | formatDate('MM-DD HH:mm') }}</span>
                            <span v-else>
                                <vantCountDown :time="groupOfferData.countdown" :millisecond="false" @onCountDown="onCountDown" />
                            </span>
                        </div>
                    </div>
                    <div class="more" @click="onClick(groupOfferData)">
                        <span class="tip">更多</span>
                        <span class="icon"></span>
                    </div>
                </div>
            </div>
            <div class="commodityLess" v-if="groupOfferData.items.length < 3">
                <div v-for="(item, index) in groupOfferData.items" :key="index" class="item" :class="{'itemOpacity': item.remainingNumber <= 0}" v-show="!index" @click="onClick(groupOfferData)">
                    <div class="img">
                        <img v-lazy="$viewImageNew(item.defaultImageUrl, 400,400)" alt="">
                    </div>
                    <div class="content">
                        <div class="name f28 col000">{{ item.skuShowName }}</div>
                        <div class="single" v-show="item.sellingPoint">{{ item.sellingPoint }}</div>
                        <div class="fot">
                            <div class="saleP" v-if="$isPriceShow()"><i class="icon"></i><i>￥</i>{{ item.groupPrice }}</div>
                            <div class="saleP isPrice" v-else>会员价</div>
                            <i class="originP">￥{{ item.sellPrice }}</i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="commodity" v-else>
                <div v-for="(item, index) in groupOfferData.items" :key="index" class="item" :class="{'itemOpacity': item.remainingNumber <= 0, 'mr20': groupOfferData.items.length>3}" @click="onClick(groupOfferData)">
                    <div class="pic picMoney">
                        <img v-lazy="$viewImageNew(item.defaultImageUrl, 400,400)" alt="商品图片">
                    </div>
                    <div class="character">
                        <div class="name">{{item.skuShowName}}</div>
                        <div class="fot">
                            <div class="saleP" v-if="$isPriceShow()"><i class="icon"></i><i>￥</i>{{ item.groupPrice }}</div>
                            <div class="saleP isPrice" v-else><i class="icon"></i>会员价</div>
                            <i class="originP">￥{{ item.sellPrice }}</i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vantCountDown from '../../common/homeCountDown'
export default {
    name: 'groupOffer',
    components: {
        vantCountDown
    },
    props: {
        groupOfferData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    methods: {
        onCountDown () {
            this.$emit('groupCountDown')
        },
        onClick (item) {
            this.$emit('groupClick', item)
        }
    }
}
</script>
<style lang="scss" scoped>
.memberInfo {
    padding: 18px 24px;
    .content {
        background: #ffffff;
        border-radius: 12px;
        .flex {
            display: flex;
            justify-content: space-between;
            .group {
                width: 100%;
                font-size: 34px;
                color: #ff4d4f;
                height: 48px;
                line-height: 48px;
                display: flex;
                justify-content: space-between;
                .name {
                    flex: 1;
                    display: flex;
                    align-self: start;
                    align-items: center;
                }
                .title {
                    line-height: 48px;
                    font-weight: bold;
                    color: #1a1a1a;
                    margin-right: 20px;
                }
                .downTime {
                    position: relative;
                    font-size: 20px;
                    font-weight: 500;
                    height: 36px;
                    line-height: 36px;
                    border: 2px solid #ff571f;
                    border-radius: 36px;
                    // margin-top: 8px;
                    display: flex;
                    box-sizing: border-box;
                    span {
                        box-sizing: border-box;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &:first-child {
                            width: 96px;
                            position: absolute;
                            top: -2px;
                            left: -2px;
                            background: #ff571f;
                            border-radius: 34px;
                            color: #ffffff;
                            text-align: center;
                        }
                        &:last-child {
                            padding: 0 12px 0 108px;
                            font-size: 24px;
                        }
                        i {
                            display: inline-block;
                        }
                    }
                }
                .more {
                    font-size: 26px;
                    line-height: 36px;
                    color: #888888;
                    display: flex;
                    align-items: center;
                    .icon {
                        width: 40px;
                        height: 40px;
                        background: url(../../../../assets/img/b2b/img_arrow_next@2x.png)
                            no-repeat;
                        background-size: cover;
                    }
                }
            }
        }
    }
}
.specialTime {
    height: 32px;
    line-height: 32px;
    font-size: 24px;
    transform-origin: right 0%;
    font-weight: 500;
    padding-top: 8px;
    .time {
        color: #ff4d4f;
        border-left: 0;
        border: 2px solid #ff4d4f;
        border-radius: 20px;
        .title {
            border: 2px solid #ff4d4f;
            color: #ffffff;
            background-color: #ff4d4f;
            padding: 0 16px;
            border-radius: 20px;
        }
        .acativeTime {
            padding: 0 16px 0 28px;
        }
        &.time2 {
            color: #cccccc;
            border: 2px solid #cccccc;
            .title {
                border: 2px solid #cccccc;
                background-color: #cccccc;
            }
        }
    }
}
.commodity {
    padding-top: 24px;
    overflow-x: overlay;
    white-space: nowrap;
    display: flex;
    justify-content: space-around;
    .itemOpacity {
        opacity: 0.5;
    }
    .item {
        display: flex;
        justify-content: flex-start;
        flex: 0 0 230px;
        display: inline-block;
        padding-bottom: 18px;
        &:nth-child(-n + 3) {
            padding-top: 0;
        }
        .pic {
            position: relative;
            flex: 0 0 230px;
            height: 230px;
            background-color: #f5f5f5;
            display: flex;
            img {
                align-self: center;
                justify-self: center;
                border-radius: 2px;
                display: inline-block;
                margin: 0 auto;
                background: #f2f3f5;
                object-fit: cover;
            }
        }
        box-sizing: border-box;
        .character {
            position: relative;
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            align-content: space-between;
            box-sizing: border-box;
            .name {
                text-align: left;
                font-size: 24px;
                line-height: 36px;
                padding-right: 14px;
                height: 36px;
                width: 100%;
                color: #333333;
                font-weight: 400;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                white-space: normal;
                word-break: break-all;
                margin-bottom: 8px;
                margin-top: 18px;
            }
            .saleOut {
                margin: 0 auto;
                font-size: 20px;
                color: #999999;
                transform: scale(0.8);
                transform-origin: left bottom;
            }
            .fot {
                font-weight: bold;
            }
            .saleP {
                width: 100%;
                height: 32px;
                font-size: 32px;
                line-height: 32px;
                margin-bottom: 4px;
                font-weight: bold;
                color: #ff571f;
                font-family: Helvetica;
                i {
                    display: inline-block;
                    font-size: 24px;
                    transform: scale(0.92);
                    transform-origin: left -130%;
                    &.icon {
                        width: 28px;
                        height: 28px;
                        transform: scale(1);
                        background: url("../../../../assets/img/b2b/time3.png")
                            no-repeat;
                        background-size: 100% 100%;
                    }
                }
                &.isPrice {
                    font-size: 28px;
                }
            }
            .originP {
                height: 28px;
                line-height: 28px;
                font-size: 24px;
                text-decoration: line-through;
                transform: scale(0.83);
                transform-origin: left 80%;
                color: #999999;
                &.ml8 {
                    margin-left: 8px;
                }
            }
        }
        &.mr20 {
            margin-right: 20px;
        }
    }
}
.commodityLess {
    padding-top: 24px;
    .item {
        position: relative;
        display: flex;
        justify-content: flex-start;
        width: 100%;
        padding-bottom: 18px;
        &:nth-child(-n + 3) {
            padding-top: 0;
        }
        .img {
            flex: 0 0 230px;
            font-size: 0;
            height: 230px;
            background-color: #fafafa;
            display: flex;
            img {
                border-radius: 4px;
                display: inline-block;
                margin: 0 auto;
                align-self: center;
                justify-self: center;
                background: #f2f3f5;
                object-fit: cover;
            }
        }
        .content {
            margin: 0;
            padding: 4px 4px 8px 24px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .name {
                font-size: 28px;
                line-height: 40px;
                color: #333333;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                white-space: normal;
                word-break: break-all;
            }
            .single {
                font-size: 24px;
                color: #999999;
            }
            .saleOut {
                font-size: 20px;
                color: #999999;
                transform: scale(0.8);
                transform-origin: left bottom;
            }
            .fot {
                font-weight: bold;
                .saleP {
                    width: 100%;
                    height: 32px;
                    font-size: 32px;
                    line-height: 32px;
                    margin-bottom: 6px;
                    color: #ff571f;
                    font-family: Helvetica;
                    i {
                        display: inline-block;
                        font-size: 24px;
                        transform: scale(0.92);
                        transform-origin: left -130%;
                        &.icon {
                            width: 28px;
                            height: 28px;
                            transform: scale(1);
                            background: url("../../../../assets/img/b2b/time3.png")
                                no-repeat;
                            background-size: 100% 100%;
                        }
                    }
                    &.isPrice {
                        font-size: 32px;
                    }
                }
                .originP {
                    height: 28px;
                    line-height: 28px;
                    font-size: 24px;
                    text-decoration: line-through;
                    transform: scale(0.83);
                    transform-origin: left 80%;
                    color: #999999;
                    &.ml8 {
                        margin-left: 8px;
                    }
                }
            }
        }
    }
}
/deep/ .count span {
    font-size: 24px;
}
/deep/ .count .time {
    align-items: center;
}
</style>
